/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { AbilityBuilder, Ability } from "@casl/ability";
import {
  ADMIN_CANNOT_ABILITY,
  ADMIN_CAN_ABILITY,
  MASQUERADER_CANNOT_ABILITY,
  MASQUERADER_CAN_ABILITY,
  PACKER_ADMIN_CANNOT_ABILITY,
  PACKER_ADMIN_CAN_ABILITY,
  PACKER_CANNOT_ABILITY,
  PACKER_CAN_ABILITY,
  TOKEN_ISSUER_CANNOT_ABILITY,
  TOKEN_ISSUER_CAN_ABILITY,
  CASHIER_CANNOT_ABILITY,
  CASHIER_CAN_ABILITY,
  PICKER_CANNOT_ABILITY,
  PICKER_CAN_ABILITY,
  DISTRIBUTOR_CANNOT_ABILITY,
  DISTRIBUTOR_CAN_ABILITY,
} from "../roles";

export const defineAbilityFor = (whoami: string) => {
  const ability: any = new AbilityBuilder(Ability);
  console.log("whoami", whoami);
  let _whoami = whoami && whoami.split("-")[2];
  _whoami = _whoami ? _whoami : whoami;
  console.log(`_whoami ::`, _whoami);
  if (_whoami === "owner") {
    ability.can("manage", "all"); // read-write access to everything
  } else if (_whoami === "admin") {
    ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "masq") {
    MASQUERADER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    MASQUERADER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "packer-admin") {
    PACKER_ADMIN_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    PACKER_ADMIN_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "packer") {
    PACKER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    PACKER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "tokenkiosk") {
    TOKEN_ISSUER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    TOKEN_ISSUER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "cashier") {
    CASHIER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    CASHIER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "picker") {
    PICKER_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    PICKER_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else if (_whoami === "distributor") {
    DISTRIBUTOR_CAN_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.can(able[0], able[1]);
      }
    });
    DISTRIBUTOR_CANNOT_ABILITY?.forEach((able: any) => {
      if (able[0] && able[1]) {
        ability.cannot(able[0], able[1]);
      }
    });
  } else {
    ability.cannot("read", "all"); // read-only access to everything
  }
  return ability.build();
};
